import { render, staticRenderFns } from "./WhyTakeIn.vue?vue&type=template&id=76794df1&scoped=true&"
import script from "./WhyTakeIn.vue?vue&type=script&lang=js&"
export * from "./WhyTakeIn.vue?vue&type=script&lang=js&"
import style0 from "./WhyTakeIn.vue?vue&type=style&index=0&id=76794df1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76794df1",
  null
  
)

export default component.exports